import styled from '@emotion/styled';

export const Container = styled.div`
    display: flex;
    gap: ${({ theme }) => theme.spacing[2]};
    flex-direction: column;
    padding: ${({ theme }) => theme.spacing[4]};
`;
